import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ArrowsMaximizeIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/arrows-maximize"><g id="Icon"><path d="M19.2 6.07279L14.3364 10.9364C13.9849 11.2879 13.4151 11.2879 13.0636 10.9364C12.7121 10.5849 12.7121 10.0151 13.0636 9.6636L17.9272 4.8H14.7C14.2029 4.8 13.8 4.39706 13.8 3.9C13.8 3.40294 14.2029 3 14.7 3H20.1C20.5971 3 21 3.40294 21 3.9V9.3C21 9.79706 20.5971 10.2 20.1 10.2C19.6029 10.2 19.2 9.79706 19.2 9.3V6.07279Z" fill="currentColor" /><path d="M3 14.7V20.1C3 20.222 3.02429 20.3384 3.06829 20.4445C3.11221 20.5507 3.17731 20.6501 3.2636 20.7364C3.43934 20.9121 3.66967 21 3.9 21H9.3C9.79706 21 10.2 20.5971 10.2 20.1C10.2 19.6029 9.79706 19.2 9.3 19.2H6.07279L10.9364 14.3364C11.2879 13.9849 11.2879 13.4151 10.9364 13.0636C10.5849 12.7121 10.0151 12.7121 9.6636 13.0636L4.8 17.9272V14.7C4.8 14.2029 4.39706 13.8 3.9 13.8C3.40294 13.8 3 14.2029 3 14.7Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowsMaximizeIcon;